import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NewsTopic } from "../typeDefs/marketData";

export interface MarketDataState {
	newsTopics: NewsTopic[];
	newsTopicsLoading: boolean;
}

const initialState: MarketDataState = {
	newsTopics: [],
	newsTopicsLoading: false,
};

export const marketDataSlice = createSlice({
	name: "marketData",
	initialState,
	reducers: {
		setNewsTopics: (state, action: PayloadAction<NewsTopic[]>) => {
			state.newsTopics = action.payload;
		},
		setNewsTopicsLoading: (state, action: PayloadAction<boolean>) => {
			state.newsTopicsLoading = action.payload;
		},
	},
});

export const { setNewsTopics, setNewsTopicsLoading } = marketDataSlice.actions;

export default marketDataSlice.reducer;
